"use strict";

var $ = window.jQuery;

var hostname = window.location.hostname === "localhost" ? "http://www.uni.gl" : "";

var reloadTable = function reloadTable(date) {
  $.ajax({
    url: "?update=true"
  }).done(function (data) {
    var basketBoxHtml = $(data).find(".basket--box").html();
    if (basketBoxHtml != null && basketBoxHtml.length > 0) {
      $(".basket--box").html(basketBoxHtml);
    }

    var menuItemBasketHtml = $(data).find(".menu-item--basket").html();
    if (menuItemBasketHtml != null && menuItemBasketHtml.length > 0) {
      $(".menu-item--basket").html(menuItemBasketHtml);
    }

    var basketHtml = $(data).find(".basket").html();
    if (basketHtml != null && basketHtml.length > 0) {
      $(".basket").html(basketHtml);
    }
  });
};

window.clearCart = function () {
  return $.ajax({
    type: "POST",
    url: hostname + "/umbraco/surface/Webshop/ClearCurrentOrder",
    data: {}
  });
};

$(function () {
  $(".basket").parent().on("click", "*[data-remove-cart-item]", function (event) {
    var $target = $(event.target);
    var id = $target.data("remove-cart-item");
    var options = $target.data("remove-cart-item-options");

    var formData = {
      productId: id,
      options: options
    };

    $.ajax({
      type: "POST",
      url: hostname + "/umbraco/surface/Webshop/RemoveProductFromCart/",
      data: formData,
      success: function success() {
        reloadTable();
      }
    }).fail(function () {
      var _console;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      // This should never happen
      (_console = console).error.apply(_console, ["Could not POST"].concat(args));
      window.alert("Error - please try again");
    });

    return false;
  });
});

$(function () {
  $(".basket").parent().on("keypress", function (event) {
    var isEnter = event.which === 13;
    if (isEnter) {
      $("input").blur();
      return false;
    }
  });

  $(".basket").parent().on("change", "*[data-update-quantity]", function (event) {
    var $target = $(event.target);
    var id = $target.data("update-quantity");
    var newValue = $target.val();
    var options = $target.data("update-quantity-options");

    if (newValue == null || newValue <= 0) {
      newValue = 0;
      $target.val(newValue);
    }

    var formData = {
      productId: id,
      quantity: newValue || 0,
      options: options || ""
    };

    $.ajax({
      type: "POST",
      url: hostname + "/umbraco/surface/Webshop/SetProductQuantityInCart/",
      data: formData,
      success: function success() {
        reloadTable();
      }
    }).fail(function () {
      var _console2;

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      // This should never happen
      (_console2 = console).error.apply(_console2, ["Could not POST"].concat(args));
      $target.val(undefined);
      window.alert("Error - please try again");
    });

    return false;
  });
});

$(function () {
  var $forms = $("form[data-cart-action]");

  $('#conf-product #conf-form [name="options"]').change(function (e) {
    var prices = $("#conf-form").find('[name="options"]:checked, [name="options"] option:selected').map(function (index, element) {
      return $(element).data("price");
    }).toArray();
    var sum = prices.reduce(function (a, b) {
      return a + b;
    }, 0);
    $(".details-price").text("kr. " + sum);

    if (prices.length > 0) {
      $(".submit-button").show();
    } else {
      $(".submit-button").hide();
    }
  });

  $forms.each(function (i, form) {
    var $form = $(form);

    $form.on("submit", function (e) {
      if ($form.hasClass("validate") && !$form.valid()) {
        return; // Only submit valid forms
      }

      var $cartIcon = $(".cart-icon");
      var $spinnerIcon = $(".spinner-icon");

      $cartIcon.stop().delay(100).hide(0);
      $spinnerIcon.stop().delay(100).show(0);

      // const formData = $form.serialize()
      var formData = "options=" + $("#conf-form").find('[name="options"]:checked, [name="options"] option:selected').map(function (index, element) {
        return $(element).val();
      }).toArray().join();
      formData += "&quantity=" + $("#conf-form").find('[name="quantity"]').val();
      formData += "&productId=" + $("#conf-form").find('[name="productId"]').val();

      $.ajax({
        type: "POST",
        url: $form.data("cart-action"),
        data: formData,
        success: function success() {
          var cloneCurrentSlideImageAnimation = function cloneCurrentSlideImageAnimation() {
            var $slideshow = $(".viewer-main");
            var currentSlideIndex = $slideshow.slick("slickCurrentSlide");
            var $currentSlide = $slideshow.find(".slick-slide:nth-child(" + (currentSlideIndex + 1) + ")");
            var $currentSlideImage = $currentSlide.find("img");
            var $currentSlideImageClone = $currentSlideImage.clone();

            var $menuItemBasket = $(".menu-item--basket");

            $currentSlideImageClone.css({
              position: "absolute",
              top: $currentSlideImage.offset().top,
              left: $currentSlideImage.offset().left,
              zIndex: 9999,
              width: $currentSlideImage.outerWidth(),
              height: $currentSlideImage.outerHeight()
            });

            $currentSlideImageClone.appendTo("body");

            $currentSlideImageClone.animate({
              top: $menuItemBasket.offset().top + $menuItemBasket.outerHeight() / 3,
              left: $menuItemBasket.offset().left + $menuItemBasket.outerWidth() / 2,
              width: 10,
              height: 10
            }, 800, function () {
              $currentSlideImageClone.fadeOut().remove();
              reloadTable();
            });
          };

          var $body = $("html, body");
          if ($body.outerWidth() <= 480) {
            $body.animate({
              scrollTop: 0
            }, window.pageYOffset, function () {
              cloneCurrentSlideImageAnimation();
            });
          } else {
            cloneCurrentSlideImageAnimation();
          }
        },
        complete: function complete() {
          $cartIcon.stop().show(0);
          $spinnerIcon.stop().hide(0);
        }
      }).fail(function () {
        // This should never happen
        window.alert("Error - please try again");
      });

      // Prevent default behaviour
      return false;
    });
  });
});

$(function () {
  var $countrySelector = $("select.country-selector");

  $countrySelector.on("change", function () {
    var selected = this.value;
    var $spinnerIcon = $(".spinner-icon");

    $spinnerIcon.delay(100).show(0);

    $.ajax({
      type: "POST",
      url: hostname + "/umbraco/surface/Webshop/UpdateOrderRecipientInformationRegion/",
      data: { region: selected },
      success: function success() {
        reloadTable();
      },
      complete: function complete() {
        $spinnerIcon.stop().hide(0);
      }
    }).fail(function () {
      var _console3;

      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      // This should never happen
      (_console3 = console).error.apply(_console3, ["Could not POST"].concat(args));
      window.alert("Error - please try again");
    });
  });
  if ($(".has-conference-product").length > 0) {
    $("#delivery-area-wrapper").hide();
    var valueToSelect = $("#delivery-area-wrapper select option:first").val();
    if (valueToSelect === "" || valueToSelect === undefined) {
      valueToSelect = $("#delivery-area-wrapper select option:eq(1)").val();
    }
    $("#delivery-area-wrapper select").val(valueToSelect).trigger("chosen:updated").change();
  }

  hideInvoicePayment();
  $("#InvoicePayment").change(function (event) {
    var invoicePaymentActive = $(event.target).is(":checked");
    if (invoicePaymentActive) {
      showInvoicePayment();
    } else {
      hideInvoicePayment();
    }
  });

  $("#invoice-payment select").change(function (event) {
    var currentCustomerType = $(event.target).val();

    switch (currentCustomerType) {
      case "Privatperson":
        showInvoicePaymentPrivatePerson();
        hideInvoicePaymentCompany();
        break;
      case "Virksomhed":
        showInvoicePaymentCompany();
        hideInvoicePaymentPrivatePerson();
        break;
    }
  });

  function showInvoicePayment() {
    $("#invoice-payment *[required]").removeClass("ignore");
    $("#invoice-payment").show();
    $("#invoice-payment select").change();
    $("#submit-button").text($("#submit-button").data("text-invoice-payment"));
  }

  function showInvoicePaymentCompany() {
    $("#company-org *[required]").removeClass("ignore");
    $("#company-org").show();
    $("#company-name-not-required-info").hide();
    $("#company-name-field").attr("required", true);
  }

  function showInvoicePaymentPrivatePerson() {
    $("#private-person *[required]").removeClass("ignore");
    $("#private-person").show();
  }

  function hideInvoicePayment() {
    $("#invoice-payment *[required]").addClass("ignore");
    $("#invoice-payment").hide();
    hideInvoicePaymentCompany();
    hideInvoicePaymentPrivatePerson();
    $("#submit-button").text($("#submit-button").data("text-online-payment"));
  }

  function hideInvoicePaymentCompany() {
    $("#company-org *[required]").addClass("ignore");
    $("#company-org").hide();
    $("#company-name-not-required-info").show();
    $("#company-name-field").attr("required", false);
  }

  function hideInvoicePaymentPrivatePerson() {
    $("#private-person *[required]").addClass("ignore");
    $("#private-person").hide();
  }
});
'use strict';

var $ = window.jQuery;

window.chosenBrowserIsSupported = function () {
  if (/iP(od|hone)/i.test(window.navigator.userAgent)) {
    return false;
  }
  if (/Android/i.test(window.navigator.userAgent)) {
    if (/Mobile/i.test(window.navigator.userAgent)) {
      return false;
    }
  }
  if (/IEMobile/i.test(window.navigator.userAgent)) {
    return false;
  }
  if (/Windows Phone/i.test(window.navigator.userAgent)) {
    return false;
  }
  if (/BlackBerry/i.test(window.navigator.userAgent)) {
    return false;
  }
  if (/BB10/i.test(window.navigator.userAgent)) {
    return false;
  }
  if (window.navigator.appName === 'Microsoft Internet Explorer') {
    return document.documentMode >= 8;
  }

  return true;
};

window.initializeChosen = function () {
  $('select').chosen({
    disable_search_threshold: 10,
    inherit_select_classes: true
  });

  if (!window.chosenBrowserIsSupported()) {
    $('select').each(function () {
      var placeholder = $(this).data('placeholder');

      var option = $(this).find('option').first();
      option.val(0);
      option.text(placeholder);
      option.attr('disabled', true);
      option.attr('selected', 'selected');
    });
  }
};

$(function () {
  window.initializeChosen();
});
"use strict";

window.FontAwesomeConfig = {
  searchPseudoElements: true
};
'use strict';

var $ = window.jQuery;

if ($.validator != null) {
  $.validator.addMethod('positive-number-greater-than-zero', function (value) {
    var positiveNumberRegex = /^[1-9][0-9]*$/;
    return value != null && positiveNumberRegex.test(value);
  }, $('body').data('msg-positive-number-greater-than-zero'));
}

$(function () {
  if (window.initializeChosen) {
    window.initializeChosen();
  }

  var forms = $('form.validate');

  forms.each(function (i, form) {
    var $form = $(form);

    $form.validate({
      errorClass: 'error',
      errorElement: 'span',
      focusInvalid: false,
      invalidHandler: function invalidHandler(form, validator) {
        if (validator.numberOfInvalids() <= 0) {
          return;
        }

        if ($('html, body').outerWidth() <= 480) {
          var scrollTop = $(validator.errorList[0].element).offset().top - ($('.header').outerHeight() + 50);
          $('html, body').animate({
            scrollTop: scrollTop
          }, Math.max(200, Math.abs(scrollTop - window.pageYOffset)));
        }
      },
      ignore: '.ignore', // Don't ignore hidden fields (chosen)

      errorPlacement: function errorPlacement($error, $element) {
        var chosenEnabled = window.chosenBrowserIsSupported();
        var $errorElement = $element;

        if (chosenEnabled && $element.is('select')) {
          $errorElement = $element.siblings('.chosen-container');
        }

        if ($element.attr('type') === 'checkbox') {
          $error.insertBefore($errorElement);
        } else {
          $error.insertAfter($errorElement);
        }

        $errorElement.addClass('error');
      },

      success: function success(error, element) {
        var chosenEnabled = window.chosenBrowserIsSupported();
        var $element = $(element);

        var $errorElement = $element;
        if (chosenEnabled && $element.is('select')) {
          $errorElement = $element.siblings('.chosen-container');
        }

        error.remove();
        $errorElement.removeClass('error');
      }
    });
  });
});

$(function () {
  var $body = $('body');

  var getMessage = function getMessage(identifier) {
    if (!$body.attr('data-msg-' + identifier)) {
      console.error('Missing translation-data on body-element: data-msg-' + identifier + '="\xB7\xB7\xB7"');
    }

    return $body.data('msg-' + identifier);
  };

  $.extend($.validator.messages, {
    required: getMessage('required'),
    email: getMessage('email')
  });
});

$(function () {
  var $forms = $('form[data-form-action]');

  $forms.each(function (i, form) {
    var $form = $(form);

    $form.on('submit', function () {
      if ($form.hasClass('validate') && !$form.valid()) {
        return; // Only submit valid forms
      }

      var $formElement = $form.find('.form');
      var $workIndicatorElement = $form.find('.work-indicator');
      var $successElement = $form.find('.success');

      $formElement.hide();
      $workIndicatorElement.show();

      var formData = $form.serialize();

      $.ajax({
        type: 'POST',
        url: $form.data('form-action'),
        data: formData,
        success: function success() {
          if (window.PaymentWindow != null) {

            $.ajax({
              type: 'POST',
              url: hostname + '/umbraco/surface/Webshop/SaveCurrentOrder/',
              data: {},
              success: function success(response) {
                if (response.Completed) {
                  window.location = window.accepturl;
                  return;
                }
                var salt = 'sedquamerat';
                var options = {
                  merchantnumber: '1030745', // development: 8030745
                  amount: '' + response.TotalPriceIncludingShipping * 100,
                  currency: 'DKK',
                  orderid: '' + response.PageId,
                  accepturl: window.accepturl,
                  cancelurl: window.cancelurl,
                  callbackurl: window.location.protocol + '//' + window.location.host + '/umbraco/surface/Webshop/PaymentCallback/'
                };

                var tmp = "";
                Object.keys(options).map(function (key) {
                  return tmp += options[key];
                });
                options.hash = CryptoJS.MD5(tmp + salt);

                var paymentwindow = new PaymentWindow(options);
                paymentwindow.open();
              }
            }).fail(function () {
              var _console;

              for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              // This should never happen
              (_console = console).error.apply(_console, ['Could not POST'].concat(args));
              window.alert('Error - please try again');
            });
          } else {
            var redirectUrl = $form.data('form-success-redirect');
            if (!(redirectUrl == null)) {
              window.location = redirectUrl;
            } else {
              $workIndicatorElement.hide();
              $successElement.show();
            }
          }
        }
      }).fail(function () {
        // This should never happen
        $workIndicatorElement.hide();
        $formElement.show();
        window.alert('Error - please try again');
      });

      // Prevent default behaviour
      return false;
    });
  });
});
'use strict';

function isTabletWidth() {
  return $('.mediaquery--tablet').is(':visible');
}
'use strict';

var $ = window.jQuery;

function headerUpdate() {
  if (!isTabletWidth()) {
    if ($(window).scrollTop() > $('.header-bar').height()) {
      $('.header').css('top', $('.header-bar').height() * -1);
    } else {
      $('.header').css('top', $(window).scrollTop() * -1);
    }
  } else {
    $('.header').css('top', '0');
  }
}

$(window).on('scroll', headerUpdate);

$(window).resize(function () {
  headerUpdate();
});

$(function () {

  headerUpdate();
});
'use strict';

var $ = window.jQuery;

$(function () {
  var burger = $('.header-burger');
  var html = $('html');

  window.openMobileMenu = function () {
    var mobileMenu = $('.mobilemenu');
    var isActive = mobileMenu.hasClass('mobilemenu--active');

    if (isActive) {
      burger.removeClass('header-burger--active');
      html.removeClass('mobilemenu--isopen');
    } else {
      burger.addClass('header-burger--active');
      html.addClass('mobilemenu--isopen');
    }

    mobileMenu.toggleClass('mobilemenu--active');

    return false;
  };

  burger.click(window.openMobileMenu);
});
'use strict';

var $ = window.jQuery;

$(function () {
  var $pageSelectors = $('.page-selector');

  $pageSelectors.on('change', function () {
    window.location.href = $(this).val();
  });
});
'use strict';

var $ = window.jQuery;

$(function () {

  $('.popup-trigger').magnificPopup({
    type: 'inline',
    midClick: true,
    removalDelay: 300,
    mainClass: 'mfp-zoom-in'
  });
});
'use strict';

var $ = window.jQuery;

$(function () {
  $('.slideshow').slick({
    dots: true,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    slide: '.slideshow-slide',
    appendDots: $('.slideshow-controls')
  });
});
'use strict';

var $ = window.jQuery;

$(function () {
  var oldHeight = -1;

  var onResize = function onResize() {
    var footer = $('footer.footer');
    var footerHeight = footer.innerHeight();
    if (oldHeight === footerHeight) {
      return; // skip if the height has not changed since last time
    }

    $('.sticky-footer-page-content-wrapper').css({ marginBottom: +(footerHeight * -1) + 'px' });
    $('#sticky-footer-styling').remove();

    $('<style id="sticky-footer-styling">.sticky-footer-page-content-wrapper::after{height:' + footerHeight + 'px !important}</style>').appendTo('head');
  };

  $(window).resize(onResize);
  onResize();
});
'use strict';

var $ = window.jQuery;

var updateHeight = function updateHeight() {
  var $element = $('.viewer-main .slick-slide');

  $element.height('auto');
  var slideHeight = $('.viewer-main .slick-track').height();
  $element.css('height', slideHeight);
};

$(function () {
  var $viewerMain = $('.viewer-main');
  var $viewerNav = $('.viewer-nav');

  $viewerMain.on('init', function () {
    updateHeight();
    $(window).resize(updateHeight);
  });

  $viewerMain.on('beforeChange', function () {
    $('.slick-active').removeClass('slick-active');
  });

  $viewerMain.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    draggable: true,
    infinite: false,
    asNavFor: '.viewer-nav'
  });

  $viewerNav.slick({
    centerMode: false,
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 5,
    arrows: false,
    asNavFor: '.viewer-main',
    focusOnSelect: true,
    draggable: false,
    swipe: false,
    responsive: [{
      breakpoint: 720,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }]
  });
});